import { render, staticRenderFns } from "./StayGroupedGoods.vue?vue&type=template&id=6203c4b8&scoped=true&"
import script from "./StayGroupedGoods.vue?vue&type=script&lang=js&"
export * from "./StayGroupedGoods.vue?vue&type=script&lang=js&"
import style0 from "./StayGroupedGoods.vue?vue&type=style&index=0&id=6203c4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203c4b8",
  null
  
)

export default component.exports